<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path fill="currentColor" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm3.9 13l-5.7 3.4c-.5.3-1.1-.1-1.1-.6V9c0-.5.6-.9 1.1-.6l5.7 3.4c.5.2.5.9 0 1.2z" />
  </svg>
</template>
